import {
  MEYA_SCRIPT_URL,
  MEYA_FONT_URL,
  MEYA_GRID_URL
} from '../../config/endpoints'
import { MEYA_INTEGRATION_ID, MEYA_THREAD_ID } from '../../config/integrations'

const FULLSCREEN_BREAKPOINT = '(max-width: 1024px)'

export function isMeyaMounted() {
  return document.querySelector('.orb-chat-mount') != null
}

export function initMeya({ userId, pageContext, launcherText }) {
  if (isMeyaMounted()) return

  const useFullscreen = window.matchMedia(FULLSCREEN_BREAKPOINT).matches

  window.orbConfig = {
    connectionOptions: {
      gridUrl: MEYA_GRID_URL,
      appId: import.meta.env.VITE_MEYA_APP_ID,
      integrationId: MEYA_INTEGRATION_ID,
      connect: false,
      userId,
      threadId: MEYA_THREAD_ID,
      pageContext
    },
    windowApi: true,
    mode: useFullscreen ? 'fullscreen' : 'floating',
    launcher: {
      type: 'message',
      text: launcherText
    }
  }

  const script = document.createElement('script')
  script.src = MEYA_SCRIPT_URL
  script.type = 'text/javascript'
  script.async = true
  document.body.appendChild(script)

  const font = document.createElement('link')
  font.rel = 'stylesheet'
  font.href = MEYA_FONT_URL
  document.body.appendChild(font)
}
